import { render, staticRenderFns } from "./TrafficViolationApprove.vue?vue&type=template&id=504da0d8"
import script from "./TrafficViolationApprove.vue?vue&type=script&lang=js"
export * from "./TrafficViolationApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports